export { bankAccountEditRoute } from './route'
